
import React from 'react';
import { FacilityOrderPatientNewFlowInsuranceEditModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderPatientNewFlowInsuranceEditModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderPatientNewFlowInsuranceEditModalStore(rootStore, componentProps), 'facilityOrderPatientNewFlowInsuranceEditModalStore')
@observer
class FacilityOrderPatientNewFlowInsuranceEditModal extends React.Component {
    render() {
        return <FacilityOrderPatientNewFlowInsuranceEditModalTemplate {...this.props} />
    }
}

export default FacilityOrderPatientNewFlowInsuranceEditModal;
